export const dialogPt = () => {
  return {
    title: 'font-18-n'
  }
}

export const dialogConfig = () => {
  return {
    colorScheme: {
      light: {
        root: {
          background: 'var(--site-bg)',
          borderColor: 'transparent',
          borderRadius: '20px',
        }
      },
      dark: {
        root: {
          background: 'var(--site-bg)',
          borderColor: 'transparent',
          borderRadius: '20px',
        },
      }
    },
    
  }
}
